export const RecordSettingsFragment = gql`
  fragment RecordSettingsFragment on RecordSettings {
    advancePastInspectionsMode
    allowAnonymousSubmissions
    defaultInvoiceDueDateTemplate {
      ...DateTemplateFragment
    }
    defaultLetterhead {
      id
    }
    enableApplicantDocumentPrivacy
    enableCloseRecord
    enableAddWorkflow
    finalReviewerUser {
      ...UserDataFragment
    }
    shouldDisablePlanReviewAcceptedEmail
    shouldPromoteTagsForStaff
    shouldExposeTagsToCitizens
    disableApplicantsUploadFilesNotInPlanSet
    inspectionSchedulingIntakeFormFieldGroup {
      id
    }
    inspectionCoordinationType
    inspectionCutoffTime
    inspectionMaxTries
    inspectionSchedulingInstructions
    inspectionRequestSchedulingMode
    issuedIdentifierYearCutoff {
      day
      month
    }
    lateFee {
      id
    }
    setExpirationAtIssueDateTemplate {
      ...DateTemplateFragment
    }
    setExpirationAtIssueRecordTypeStatus {
      ...RecordTypeStatusFragment
    }
    shouldDisablePlanReviewAcceptedEmail
    trackApplicants
  }
`

export const OverridableRecordSettingsFragment = gql`
  fragment OverridableRecordSettingsFragment on RecordSettings {
    disableApplicantsUploadFilesNotInPlanSet
    finalReviewerUser {
      ...UserDataFragment
    }
    setExpirationAtIssueDateTemplate {
      ...DateTemplateFragment
    }
  }
`

export const OverridableRecordSettingSourcesFragment = gql`
  fragment OverridableRecordSettingSourcesFragment on RecordSettingSources {
    disableApplicantsUploadFilesNotInPlanSet {
      ...RecordSettingSourceFragment
    }
    finalReviewerUser {
      ...RecordSettingSourceFragment
    }
    setExpirationAtIssueDateTemplate {
      ...RecordSettingSourceFragment
    }
  }
`

export const RecordSettingSourceFragment = gql`
  fragment RecordSettingSourceFragment on RecordSettingSource {
    id
    type
  }
`
